import type { TLMSAdminEditableField, TLMSAdminFormValues } from './types'

export const buildAdminFormPayload = ({
  mode,
  values,
  editableFields = [],
}: {
  mode: 'create' | 'update'
  values: TLMSAdminFormValues
  editableFields?: TLMSAdminEditableField[]
}): TLMSAdminFormValues => {
  const { name, ...valuesWithoutName } = values
  const normalizedName = name?.trim()

  if (mode === 'create') {
    return {
      ...valuesWithoutName,
      ...(normalizedName ? { name: normalizedName } : {}),
    }
  }

  const updateValues: TLMSAdminFormValues = {
    email: values.email,
  }

  if (editableFields.includes('name') && normalizedName) {
    updateValues.name = normalizedName
  }

  if (editableFields.includes('role')) {
    updateValues.role = values.role
  }

  return updateValues
}
